// extracted by mini-css-extract-plugin
export default {"header":"Header_header__rAOWO","headerTop":"Header_headerTop__bl5CM","titleWrapper":"Header_titleWrapper__iYkU5"};